import { makeStyles, Theme } from '@material-ui/core/styles';
import { SpinnerAlignment } from './Spinner';

export const useSpinnerStyles = makeStyles((theme: Theme) => ({
    [SpinnerAlignment.CENTERED]: {
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
    },
}));
